import { Button, TOUCH } from "@nymbl/nos2-rules";
import { Download } from "lucide-react";
import { isPdf, receiptContentType } from "@/lib/expenses/receipts";
import type { ReceiptView } from "@/schemas/expenses";

/** One receipt inline: images and PDFs show; anything else is a download. */
export function ReceiptPreview({ receipt }: { receipt: ReceiptView }) {
  const url = `/api/expenses/receipt?id=${receipt.id}`;
  const inline = receiptContentType(receipt.fileName) !== null;
  return (
    <figure className="flex flex-col gap-2 rounded-lg border bg-card p-2">
      {inline &&
        (isPdf(receipt.fileName) ? (
          <iframe
            title={`Receipt ${receipt.fileName}`}
            src={url}
            className="h-96 w-full rounded border-0"
          />
        ) : (
          <img
            src={url}
            alt={`Receipt ${receipt.fileName}`}
            loading="lazy"
            className="max-h-96 w-full rounded object-contain"
          />
        ))}
      <figcaption className="flex items-center justify-between gap-2 text-sm">
        <span className="min-w-0 truncate">{receipt.fileName}</span>
        <Button asChild type="button" variant="ghost" size="icon" className={TOUCH}>
          <a href={url} download={receipt.fileName} aria-label={`Download ${receipt.fileName}`}>
            <Download className="size-4" aria-hidden="true" />
          </a>
        </Button>
      </figcaption>
    </figure>
  );
}
